// @flow

const debug = require('../debug/debug')('wc:util:EventUtil');

/**
 * Returns the clientX and clientY of either a MouseEvent
 * or a TouchEvent.
 *
 * @param {MouseEvent | TouchEvent} event
 * @returns { clientX: Number, clientY: Number } clientX and clientY
 */
export function getClientXY(event: MouseEvent | TouchEvent) {
  let x = 0,
    y = 0;

  if (event.clientX) {
    x = event.clientX;
    y = event.clientY;
  }

  if (event.changedTouches && event.changedTouches.length === 1) {
    x = event.changedTouches[0].clientX;
    y = event.changedTouches[0].clientY;
  }


  return [x, y];
}
